import { Button, Space, Typography } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useDashboard } from './hooks/useDashboard';
import StatCards from './components/StatCards';
import TrendCharts from './components/TrendCharts';
import AiCharts from './components/AiCharts';
import DistributionCharts from './components/DistributionCharts';
import RealtimePanel from './components/RealtimePanel';

const { Title } = Typography;

export default function DashboardPage() {
  const { overview, trends, distribution, realtime, loading, refresh } = useDashboard();

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <Title level={4} style={{ margin: 0 }}>仪表盘</Title>
        <Button icon={<ReloadOutlined />} onClick={refresh} loading={loading}>刷新数据</Button>
      </div>

      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <StatCards data={overview} loading={loading} />
        <TrendCharts data={trends} loading={loading} />
        <AiCharts data={trends} loading={loading} />
        <DistributionCharts data={distribution} loading={loading} />
        <RealtimePanel data={realtime} loading={loading} />
      </Space>
    </div>
  );
}
